export const appConfig = {
    appId: 'com.nusrif.ecom',
    appName: 'nusrif',
    firebase: {
        apiKey: "AIzaSyBEMSrT3wI9y2JfbGS_LlGzKl3MGMudoIE",
        authDomain: "nusrif-ecommerce-store.firebaseapp.com",
        projectId: "nusrif-ecommerce-store",
        storageBucket: "nusrif-ecommerce-store.firebasestorage.app",
        messagingSenderId: "1023871159843",
        appId: "1:1023871159843:web:d393fe8af2b8eca84fab96",
        vapidKey: 'BEgCEbl9UalxYlsDTIpfbJz0I9J8SiubmT-QBkd-ianmtlXQMGyTrsmcIdqX8663pbgMjFuz8BRG4-2XWpI_qEY',
    }
};